import {
    AgreementOptions,
    CountryCode,
    Entity,
    EntityAddress,
    EntityContactDetails,
    EntityFormValues,
    EntityType,
    InvoiceType,
} from "./supportEntitiesTypes"
import {
    COMPANY_REPORTS_ROUTE,
    MERCHANT_REPORTS_ROUTE,
    SERVICE_CENTER_REPORTS_ROUTE,
    SUPPLIER_REPORTS_ROUTE,
    TENANT_REPORTS_ROUTE,
    USER_REPORTS_ROUTE,
} from "../../../../constants/routes"

export const entityContextMap = {
    [EntityType.COMPANY]: {
        contextType: "company",
        route: COMPANY_REPORTS_ROUTE,
    },
    [EntityType.SUPPLIER]: {
        contextType: "supplier",
        route: SUPPLIER_REPORTS_ROUTE,
    },
    [EntityType.MERCHANT]: {
        contextType: "merchant",
        route: MERCHANT_REPORTS_ROUTE,
    },
    [EntityType.TENANT]: {
        contextType: "tenant",
        route: TENANT_REPORTS_ROUTE,
    },
    [EntityType.SERVICE_CENTER]: {
        contextType: "serviceCenter",
        route: SERVICE_CENTER_REPORTS_ROUTE,
    },
    [EntityType.USER]: {
        contextType: "user",
        route: USER_REPORTS_ROUTE,
    },
}
export const getInvoiceDetails = (value: EntityFormValues) => {
    return (
        value.isSystemOwner === AgreementOptions.YES && {
            invoiceDetails: {
                endpoint: {
                    type: value.invoiceType as InvoiceType,
                    ...(value.invoiceType === InvoiceType.EAN_NUMBER && {
                        eanNumber: value.eanNumber,
                    }),
                    ...(value.invoiceType === InvoiceType.EMAIL && {
                        email: value.invoiceEmail,
                    }),
                },
                debitorNo: value.debitorNo,
                attention: value.attention,
                poNumber: value.poNumber,
                reminderEmail: value.reminderEmail,
            },
        }
    )
}

export const getAddress = (value: EntityFormValues): EntityAddress => {
    return {
        addressLines: [value.address1, value?.address2],
        postalCode: value.postalCode,
        city: value.city,
        countryCode: value.countryCode as CountryCode,
    }
}

function getEntityContext(entityType: EntityType, original: Entity) {
    switch (entityType) {
        case EntityType.MERCHANT:
            return {
                id: original.id,
                uid: original.uid,
                caseNumber: original.caseNumber,
                name: original.name,
                addressDisplayText: original.address.displayName,
            }

        case EntityType.TENANT:
            return {
                companyId: original.companyId,
                userGroupId: original.userGroupId,
                companyUid: original.companyUid,
                name: original.name,
                addressDisplayText: original.address.displayName,
            }

        case EntityType.USER:
            return {
                company: { id: original.companyId },
                userGroupId: original.userGroupId,
                companyUid: original.companyUid,
                name: original.name,
                addressDisplayText: original.address.displayName,
            }

        default:
            return {
                id: original.id,
                uid: original.uid,
                name: original.name,
                addressDisplayText: original?.address?.displayName || "",
            }
    }
}

export const getContactDetails = (value: EntityFormValues): EntityContactDetails => {
    return {
        name: value.contactPerson,
        email: value.email,
        phone: value.telephone,
    }
}

export const buildContextData = (entityType: EntityType, original: Entity, pathname: string) => {
    const contextData: any = {
        type: entityContextMap[entityType].contextType,
        returnUrl: pathname,
    }

    contextData[entityContextMap[entityType].contextType] = getEntityContext(entityType, original)

    return contextData
}
